import Alpine from 'alpinejs';

type AlpineType = typeof Alpine;

export const Share = (Alpine: AlpineType) => {
    Alpine.directive('share', (el: HTMLInputElement, { expression }, { cleanup, evaluate }) => {
        // eslint-disable-next-line no-undef,no-unused-vars
        const { canShare: dropField, ...shareData } = evaluate(expression) as unknown as ShareData & {
            canShare: boolean;
        };
        const setCanShare = (value: boolean) => evaluate(`${expression}.canShare = ${value}`);
        const init = (el) => {
            if (typeof navigator.canShare === 'undefined' || !navigator.canShare(shareData)) {
                setCanShare(false);
                return false;
            }
            el.addEventListener('click', handler);

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            cleanup(() => {
                el.removeEventListener('click', handler);
            });
        };
        const handler = (event: PointerEvent) => {
            event.preventDefault();
            navigator.share(shareData);
        };

        init(el);
    });
};

export default Share;
